import axios from "axios";
import config from "@/config";
import store from "@/store";
import { checkSession } from "@/store/app/action.js";

// Function to get the appropriate API endpoints based on VPN status
const getAPIEndpoints = (useVPN = false) => {
  if (useVPN) {
    return {
      ms: config.vpnMs,
      os: config.vpnOs,
      manageAPI: config.vpnManageAPI,
    };
  }

  // Default to public endpoints
  return {
    ms: config.ms,
    os: config.os,
    manageAPI: config.manageAPI,
  };
};

// Create API instances with dynamic endpoints
export const createAPIInstance = (baseURL, isManageAPI = false) => {
  const instance = axios.create({
    baseURL,
  });

  // Request interceptor to add headers
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = token;
      }
      const merchant = localStorage.getItem("selectedMerchant");
      if (merchant) {
        config.headers["x-merchant-id"] = merchant;
      }
      const location = localStorage.getItem(`selectedLocationStoreId:${merchant}`);
      if (location) {
        config.headers["x-store-id"] = location;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle x-auth-token header from manageAPI
  if (isManageAPI) {
    instance.interceptors.response.use(
      (response) => {

        let newToken = 
          response.headers["x-auth-token"] || 
          response.headers["X-Auth-Token"];
          
        
        if (newToken) {
          // Update token in localStorage
          localStorage.setItem("token", newToken);
          // Dispatch checkSession to refresh user session with new token
          store.dispatch(checkSession());
        }
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  return instance;
};

// Get current endpoints and create API instances (start with public endpoints)
const endpoints = getAPIEndpoints(false);

export let msAPI = createAPIInstance(endpoints.ms);
export let osAPI = createAPIInstance(endpoints.os);
export let manageAPI = createAPIInstance(endpoints.manageAPI, true);

// Function to recreate API instances with VPN endpoints
export const switchToVPNEndpoints = () => {
  const vpnEndpoints = getAPIEndpoints(true);
  msAPI = createAPIInstance(vpnEndpoints.ms);
  osAPI = createAPIInstance(vpnEndpoints.os);
  manageAPI = createAPIInstance(vpnEndpoints.manageAPI, true);
};

// Function to recreate API instances with public endpoints
export const switchToPublicEndpoints = () => {
  const publicEndpoints = getAPIEndpoints(false);
  msAPI = createAPIInstance(publicEndpoints.ms);
  osAPI = createAPIInstance(publicEndpoints.os);
  manageAPI = createAPIInstance(publicEndpoints.manageAPI, true);
};

/**
 * Upload a file to S3 using the presigned URL
 * @param {string} presignedUrl
 * @param {File|Blob} file
 * @param {string} contentType
 * @returns {Promise<Response>}
 */
export async function uploadFileToS3(presignedUrl, file, contentType) {
  return fetch(presignedUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": contentType,
    },
  });
}

export * from "./auth";
export * from "./orders";
export * from "./externalFeeds";
